'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPrices = exports.calculatePrices = exports.getQuotePremium = exports.getDlAttribution = exports.quotingFDI = exports.quoting = exports.hasQuoted = exports.fdiQuoteRef = exports.quoteRef = exports.getQuoteOptions = exports.getFDIQuotes = exports.getQuotes = exports.getQuoteInfo = undefined;
var _reselect = require('reselect');
var _constants = require('./constants');
var getQuoteInfo = exports.getQuoteInfo = function getQuoteInfo(state) {
  return state[_constants.NAME];
};
var getQuotes = exports.getQuotes = function getQuotes(state) {
  return getQuoteInfo(state).quotes;
};
var getFDIQuotes = exports.getFDIQuotes = function getFDIQuotes(state) {
  return getQuoteInfo(state).fdiQuotes;
};
var getQuoteOptions = exports.getQuoteOptions = function getQuoteOptions(state) {
  return getQuoteInfo(state).params;
};
var quoteRef = exports.quoteRef = function quoteRef(state) {
  return getQuoteInfo(state).quoteRef;
};
var fdiQuoteRef = exports.fdiQuoteRef = function fdiQuoteRef(state) {
  return getQuoteInfo(state).fdiQuoteRef;
};
var hasQuoted = exports.hasQuoted = function hasQuoted(state) {
  return !!quoteRef(state);
};
var quoting = exports.quoting = function quoting(state) {
  return getQuoteInfo(state).fetching;
};
var quotingFDI = exports.quotingFDI = function quotingFDI(state) {
  return getQuoteInfo(state).fetchingFDI;
};
var getDlAttribution = exports.getDlAttribution = function getDlAttribution(state) {
  return getQuoteInfo(state).dlAttribution;
};
var getQuotePremium = exports.getQuotePremium = function getQuotePremium(state, length) {
  var quotes = getQuotes(state);
  if (!quotes || quotes.length === 0) {
    return undefined;
  }
  var quote = quotes.find(function (quote) {
    return quote.cover === length;
  });
  return quote ? quote.premium : undefined;
};
var calculatePrices = exports.calculatePrices = function calculatePrices(quotes) {
  return quotes.map(function (quote) {
    return {
      day: quote.cover,
      price: quote.premium
    };
  });
};
var getPrices = exports.getPrices = (0, _reselect.createSelector)(getQuotes, calculatePrices);